import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.9837 12.9819L19.5863 13.7799C20.5044 14.9956 21.0008 16.4776 21.0003 18.0009C20.9998 19.5243 20.5023 21.0059 19.5834 22.221L18.9802 23.0185L17.385 21.8121L17.9882 21.0145C18.6446 20.1467 18.9999 19.0884 19.0003 18.0002C19.0007 16.9121 18.6461 15.8536 17.9903 14.9852L17.3877 14.1872L18.9837 12.9819Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.1909 15.0911L16.7936 15.8891C17.2526 16.4969 17.5008 17.2379 17.5006 17.9996C17.5003 18.7613 17.2516 19.5021 16.7921 20.1096L16.1889 20.9072L14.5938 19.7007L15.197 18.9032C15.3939 18.6428 15.5005 18.3253 15.5006 17.9989C15.5007 17.6724 15.3943 17.3549 15.1976 17.0944L14.5949 16.2964L16.1909 15.0911Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.8762 14C12.0139 15.103 11.5 16.4915 11.5 18C11.5 19.5085 12.0139 20.897 12.8762 22H2V20C2 16.6863 4.68629 14 8 14H12.8762Z"}}]};

const UserTalkFilled = Vue.extend<IconProps>({
  name: 'UserTalkFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'user-talk-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UserTalkFilled;
